import { Tooltip } from 'antd';
import { WarningOutlined } from '@ant-design/icons';

const WarnTriangle = (props) => {
  return (
    <Tooltip title={props.tooltip || "Warning"}>
      <WarningOutlined style={{ fontSize: '20px', color: 'orange' }} />
    </Tooltip>
  );
};

export default WarnTriangle;
